<template>
  <svg :width="width" :height="height" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.842 7.55L9.302 8.102C8.87 8.534 8.6 8.9 8.6 9.8H7.4V9.5C7.4 8.834 7.67 8.234 8.102 7.802L8.846 7.046C9.068 6.83 9.2 6.53 9.2 6.2C9.2 5.534 8.66 5 8 5C7.68174 5 7.37652 5.12643 7.15147 5.35147C6.92643 5.57652 6.8 5.88174 6.8 6.2H5.6C5.6 5.56348 5.85286 4.95303 6.30294 4.50294C6.75303 4.05286 7.36348 3.8 8 3.8C8.63652 3.8 9.24697 4.05286 9.69706 4.50294C10.1471 4.95303 10.4 5.56348 10.4 6.2C10.4 6.728 10.184 7.202 9.842 7.55ZM8.6 12.2H7.4V11H8.6V12.2ZM8 2C7.21207 2 6.43185 2.15519 5.7039 2.45672C4.97595 2.75825 4.31451 3.20021 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8C2 9.5913 2.63214 11.1174 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C9.5913 14 11.1174 13.3679 12.2426 12.2426C13.3679 11.1174 14 9.5913 14 8C14 4.682 11.3 2 8 2Z" :fill="iconColor"/>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "iconHelp",
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
